<template>
  <section>
    <h3
      class="
        $color/gray:767
        color
        layout/margin:top:page:2
        layout/padding:left:page
        layout/padding:right:page
        typography
        $typography/size:medium
      ">
      Select artists on this floor
    </h3>
    <section
      class="
        layout/grid
        layout/margin:top:baseline
        ">
      <ul
        class="
          @600/layout/flex:column
          layout/flex:row
          layout/padding:bottom:cap:2
          layout/padding:left:page
          layout/padding:right:page
          layout/scroll:horizontal
          layout/width:100%
          scrolling-container
        "
        style="
          gap: 12px;
          overflow-x: auto;
          overflow-y: hidden;
        ">
        <li v-for="artist in artists">
          <a
            data-gtm="dvg-map-artist"
            :href="`/artists/${artist.id}`"
            class="
              layout/margin:top:clear
              link/focus
          ">
            <div
              class="
                @600/layout/width
                layout/width
              "
              style="
              --600--layout--width: 260px;
              --layout--width: 144px;
            ">
              <p
                class="
                  $typography/size:large
                  typography
                ">
                  {{artist.display_name }}
              </p>
              <p
                class="
                  $color/gray:767
                  $typography/size:medium
                  $typography/weight:regular
                  color
                  layout/margin:top:cap
                  typography
                ">
                {{ artist.works_on_view_count }} {{ artist.works_on_view_count === 1 ? 'work' : 'works' }} on view
              </p>
            </div>
          </a>
        </li>
      </ul>
    </section>
  </section>
</template>

<script>
  export default {
    props: {
      artists: {
        type: Array,
        required: true
      }
    }
  }
</script>